import { motion, AnimatePresence } from "motion/react";
import { useBurrow, TOAST_ACTION_MS } from "./BurrowStore";

export function RitualToast() {
  const { state, dispatch } = useBurrow();
  const action = state.toastAction;

  return (
    <AnimatePresence>
      {state.toastMessage && (
        <motion.div
          initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: -10 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          className={`fixed left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3 overflow-hidden rounded-2xl bg-card max-w-[min(92vw,480px)] ${
            action
              ? "px-6 py-3.5 border-2 border-accent/50 shadow-2xl shadow-accent/20"
              : "px-6 py-3 border border-accent/30 shadow-xl shadow-accent/10"
          }`}
          style={{ bottom: "calc(2rem + var(--mobile-tab-bar))" }}
        >
          <span
            className="text-accent"
            style={{
              fontFamily: "'Fraunces', Georgia, serif",
              fontSize: "0.95rem",
              fontStyle: "italic",
            }}
          >
            {state.toastMessage}
          </span>
          {action && (
            <button
              onClick={() => {
                action.onAction();
                // Dismiss immediately once the action fires.
                dispatch({ type: "SET_TOAST", message: null, action: null });
              }}
              className="shrink-0 -my-1 px-3.5 py-1.5 rounded-lg bg-accent text-accent-foreground hover:opacity-90 active:scale-95 transition-all"
              style={{ fontSize: "0.82rem", fontWeight: 600 }}
            >
              {action.label}
            </button>
          )}

          {/* Countdown bar — visibly depletes over the undo window so it's clear
              there's a limited time to act. Keyed by the message so each new
              actionable toast restarts the countdown. */}
          {action && (
            <motion.div
              key={state.toastMessage}
              className="absolute bottom-0 left-0 h-[3px] bg-accent/70 rounded-full"
              style={{ transformOrigin: "left" }}
              initial={{ scaleX: 1, width: "100%" }}
              animate={{ scaleX: 0 }}
              transition={{ duration: TOAST_ACTION_MS / 1000, ease: "linear" }}
            />
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
